import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=4bbe639e&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"
import style0 from "./dialog.vue?vue&type=style&index=0&id=4bbe639e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe639e",
  null
  
)

export default component.exports